export default {
  updateTaskDetail(state, data) {
    state.taskDetail = data
  },
  updateTaskPriority(state, payload) {
    state.readTask = payload
  },
  updateTaskOptions(state, payload) {
    state.options = { ...state.options, ...payload }
  },
  updateTaskReject(state, payload) {
    state.readReject = payload
  },
  updateTaskConfig(state, payload) {
    state.taskConfig = payload
  },
  updateTaskRemarkList(state, payload) {
    state.remarkList = payload
  },
}
